import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import Navbar from "../Navbar";
import api from "../../utils/apiClient";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "react-quill/dist/quill.snow.css";
import "../../style/EditContent.css";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

function EditContent() {
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [username, setUsername] = useState("");

  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const getuser = async () => {
    const response = await api.get("usuario/getbyToken");
    setUsername(response.data.nombre);
  };

  useEffect(() => {
    const inicio = async () => {
      if (!authToken) {
        navigate("/");
      } else {
        await getuser();
      }
    };
    inicio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  useEffect(() => {
    if (type) {
      fetchContent(type);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const fetchContent = async (type) => {
    try {
      const response = await api.get("content/content/" + type);
      setTitle(response.data.type);
      setContent(response.data.body);
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  const saveContent = async () => {
    try {
      const data = { title, body: content };
      await api.post("content/content/" + type, data);
      message.success("Contenido actualizado correctamente");
    } catch (error) {
      console.error("Error saving content:", error);
    }
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ align: [] }],
      ["clean"], // remove formatting button
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
  ];

  return (
    <>
      <Navbar />
      <div className="containers">
      <div className="main-container-admin-ec">
        <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-ec">
          <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-user-title">Editar Contenido</p>
            <div className="options-edit">
              <div className="element-edit" onClick={() => setType("Nosotros")}>
                <img src="icons/aboutus.png" alt="" className="edit-icon-a" />
                <p className="title-option">Sobre Nosotros</p>
              </div>
              <div className="element-edit" onClick={() => setType("Politicas")}>
                <img src="icons/politics.png" alt="" className="edit-icon-p" />
                <p className="title-option">Políticas</p>
              </div>
              <div className="element-edit" onClick={() => setType("Avisos")}>
                <img src="icons/avisos.png" alt="" className="edit-icon-av" />
                <p className="title-option">Avisos</p>
              </div>
              <div className="element-edit" onClick={() => setType("Credito")}>
                <img src="icons/credit.png" alt="" className="edit-icon-c" />
                <p className="title-option">Solicitud de crédito</p>
              </div>
              <div className="element-edit" onClick={() => setType("Otros")}>
                <img src="icons/others.png" alt="" className="edit-icon-c" />
                <p className="title-option">Otros</p>
              </div>
            </div>
            {type === "Otros" ? (
              <>
                <input
                  type="email"
                  className="title-input"
                  placeholder="Correo Electrónico"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <input
                  type="text"
                  className="title-input"
                  placeholder="Teléfono"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                />
              </>
            ) : (
              <>
                <input
                  type="text"
                  className="title-input"
                  placeholder="Título"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <ReactQuill
                  value={content}
                  onChange={setContent}
                  modules={modules}
                  formats={formats}
                  style={{ width: "90%", height: "500px" }}
                />
              </>
            )}
            <button className="save-btn-e" onClick={saveContent}>
              GUARDAR
            </button>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default EditContent;
